export const useTouchScreen = () => {
    const isTouchScreen = (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        // @ts-expect-error Property 'msMaxTouchPoints' does not exist on type 'Navigator'. Did you mean 'maxTouchPoints'?ts(2551)
        (navigator.msMaxTouchPoints > 0))

    return {
        isTouchScreen,
    }
}
